import React from 'react';
import './TempleGallery.css';

// Import all gallery images
import img1 from '../assets/images/templeGallery/temple_gallery_1.jpg';
import img2 from '../assets/images/templeGallery/temple_gallery_2.jpg';
import img4 from '../assets/images/templeGallery/temple_gallery_4.jpg';
import img5 from '../assets/images/templeGallery/temple_gallery_5.jpg';
import img6 from '../assets/images/templeGallery/temple_gallery_6.jpg';
import img7 from '../assets/images/templeGallery/temple_gallery_7.jpg';
import img8 from '../assets/images/templeGallery/temple_gallery_8.jpg';
import img9 from '../assets/images/templeGallery/temple_gallery_9.jpg';
import img10 from '../assets/images/templeGallery/temple_gallery_10.jpg';
import img11 from '../assets/images/templeGallery/temple_gallery_11.jpg';
import img12 from '../assets/images/templeGallery/temple_gallery_12.jpg';
import img13 from '../assets/images/templeGallery/temple_gallery_13.jpg';
import img14 from '../assets/images/templeGallery/temple_gallery_14.jpg';
import img15 from '../assets/images/templeGallery/temple_gallery_15.jpg';
import img16 from '../assets/images/templeGallery/temple_gallery_16.jpg';
import img17 from '../assets/images/templeGallery/temple_gallery_17.jpg';
import img18 from '../assets/images/templeGallery/temple_gallery_18.jpg';
import img19 from '../assets/images/templeGallery/temple_gallery_19.jpg';

function TempleGallery() {
  // Array of all gallery images (temple_gallery_3 removed)
  const galleryImages = [
    img1, img2, img4, img5, img6, img7, img8, img9,
    img10, img11, img12, img13, img14, img15, img16, img17, img18, img19
  ];

  // Duplicate images for seamless infinite scroll
  const duplicatedImages = [...galleryImages, ...galleryImages, ...galleryImages];

  return (
    <section className="temple-gallery section-padding">
      <div className="container">
        <div className="gallery-header">
          <h2 className="section-title">Temple Gallery</h2>
          <p className="section-subtitle">
            Explore the divine beauty and architectural grandeur of our sacred temple
          </p>
        </div>
      </div>

      <div className="gallery-scroll-container">
        <div className="gallery-scroll-wrapper">
          <div className="gallery-track">
            {duplicatedImages.map((image, index) => (
              <div key={index} className="gallery-item">
                <img
                  src={image}
                  alt={`Temple Gallery ${(index % galleryImages.length) + 1}`}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TempleGallery;
